import { Col, DatePicker, Form, Input, InputNumber, Row } from "antd";
import { forwardRef, useEffect, useImperativeHandle } from "react";
import { DASHBOARD_LOTTOS } from "../../../../../constants/AppConstants";
import { valueDate } from "../../../../../util/utils";

const LottoInfoGeneral = forwardRef((props, ref) => {
  const { visible, data, onUpdate, isEdit } = props;
  const [form] = Form.useForm();


  useImperativeHandle(ref, () => ({
    validate: () => form.validateFields(),
    getValues: () => {
      const values = form.getFieldsValue();
      return {
        ...values,
        lottoDate: values.lottoDate ? values.lottoDate.format("YYYY-MM-DDTHH:mm:ss") : null,
        publishedDate: values.publishedDate ? values.publishedDate.format("YYYY-MM-DDTHH:mm:ss") : null,
      };
    },
  }));


  useEffect(() => {
    if (visible) {
      if (isEdit && data) {
        const initVal = {
          ...data,
          lottoDate: data?.lottoDate ? valueDate(data?.lottoDate) : null,
          publishedDate: data?.publishedDate
            ? valueDate(data?.publishedDate)
            : null,
        };

        form.setFieldsValue(initVal);
      } else if (!data) {
        form.resetFields();
      }
    } else {
      form.resetFields();
    }
  }, [visible, data, isEdit, form]);


  const handleChange = () => {
    const values = form.getFieldsValue();

    // Esto evita que se conviertan a UTC automáticamente
    const formattedValues = {
      ...values,
      lottoDate: values.lottoDate ? values.lottoDate.format("YYYY-MM-DDTHH:mm:ss") : null,
      publishedDate: values.publishedDate ? values.publishedDate.format("YYYY-MM-DDTHH:mm:ss") : null,
    };

    onUpdate(formattedValues);
  };


  return (
    <Form form={form} layout="vertical" onValuesChange={handleChange}>
      <Row>
        <Col className="px-5" xs={24} sm={12} md={8}>
          <Form.Item label={DASHBOARD_LOTTOS.COLUMNS.ID} name="lottoId">
            <Input disabled />
          </Form.Item>
        </Col>
        <Col className="px-5" xs={24} sm={12} md={8}>
          <Form.Item
            label={DASHBOARD_LOTTOS.COLUMNS.TITLE}
            name="title"
            rules={[{ required: true, message: "Titulo requerido" }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col className="px-5" xs={24} sm={12} md={8}>
          <Form.Item
            label={DASHBOARD_LOTTOS.COLUMNS.SUBTITLE}
            name="subtitle"
            rules={[{ required: true, message: "Descripción requerida" }]}
          >
            <Input />
          </Form.Item>
        </Col>
        <Col className="px-5" xs={24} sm={12} md={8}>
          <Form.Item
            label={DASHBOARD_LOTTOS.COLUMNS.TICKET_AMOUNT}
            name="ticketAmount"
            rules={[{ required: true, message: "Núm. de tickets requerido" }]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col className="px-5" xs={24} sm={12} md={8}>
          <Form.Item
            label={DASHBOARD_LOTTOS.COLUMNS.TICKET_PRICE}
            name="ticketPrice"
            rules={[{ required: true, message: "Precio por ticket requerido" }]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col className="px-5" xs={24} sm={12} md={8}>
          <Form.Item
            label={DASHBOARD_LOTTOS.COLUMNS.OPPORTUNITIES}
            name="opportunities"
            rules={[
              { required: true, message: "Núm. oportunidades requerido" },
            ]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        </Col>
        <Col className="px-5" xs={24} sm={12} md={8}>
          <Form.Item
            label={DASHBOARD_LOTTOS.COLUMNS.LOTTO_DATE}
            name="lottoDate"
            rules={[{ required: true, message: "Fecha de Rifa requerida" }]}
          >
            <DatePicker
              style={{ width: "100%" }}
              showTime
              format="YYYY-MM-DD HH:mm:ss"
            />
          </Form.Item>
        </Col>
        <Col className="px-5" xs={24} sm={12} md={8}>
          <Form.Item
            label={DASHBOARD_LOTTOS.COLUMNS.PUBLISHED_DATE}
            name="publishedDate"
            rules={[{ required: true, message: "Fecha Publicación requerida" }]}
          >
            <DatePicker
              style={{ width: "100%" }}
              showTime
              format="YYYY-MM-DD HH:mm:ss"
            />
          </Form.Item>
        </Col>
        <Col className="px-5" xs={24} sm={12} md={8}>
          <Form.Item
            label={DASHBOARD_LOTTOS.COLUMNS.LOTTO_NUMBER}
            name="lottoNumber"
            rules={[
              { required: true, message: "Núm. de sorteo requerido" },
            ]}
          >
            <InputNumber style={{ width: "100%" }} />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
});

export default LottoInfoGeneral;
